/**
 * Created by lzy 19-11-03
 * 百家号废稿箱路由
 */
'use strict';
angular.module('editWeiboDraftBoxRouterModule', []).config([
    '$stateProvider',
    '$urlRouterProvider',
    function($stateProvider, $urlRouterProvider) {
        $stateProvider.state('front.editctr.weibo.draftbox', {
            url: '/draftbox?wbchannelid&channelid', // wbchannelid->账号
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/weibo/draftBox/main.html',
                    controller: 'EditWeiboDraftBoxCtrl',
                },
            },
        });
    },
]);
